function takePhoto(onSuccess, onError) {
  const { lib } = window;
  if (lib && lib.windvane && lib.windvane.call) {
    lib.windvane.call(
      'WVCamera',
      'takePhoto',
      {
        type: '1',
        v: '2.0',
        mode: 'camera',
        bizCode: 'infinity-lazada-sg',
      },
      onSuccess,
      onError
    );
  }
}

function uploadPhoto(onSuccess, onError) {
  const { lib } = window;
  if (lib && lib.windvane && lib.windvane.call) {
    lib.windvane.call(
      'WVCamera',
      'takePhoto',
      {
        type: '1',
        v: '2.0',
        mode: 'photo',
        bizCode: 'infinity-lazada-sg',
      },
      onSuccess,
      onError
    );
  }
}

export default {
  takePhoto,
  uploadPhoto,
};



// WEBPACK FOOTER //
// ./src/utils/windvane.js